import * as yup from "yup";

export const seeDemoSchema = yup.object().shape({
  company_name: yup.string().required("Company name is required"),
  email: yup.string().email().required("Email is required"),
  // industry_type: yup.string().required("Industry type is required"),
});
